import { render } from "./NewOrder.vue?vue&type=template&id=865f8ae6"
import script from "./NewOrder.vue?vue&type=script&lang=js"
export * from "./NewOrder.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tom/tom/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__